import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { setError } from "../../reducers/appSlice";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

import * as Yup from "yup";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { visuallyHidden } from "@mui/utils";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCellMui from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";

import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import MinimalPage from "../../layout/MinimalPage";
import api from "../../service/api";
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import SeleccionarOrganismo from "../../commons/SeleccionarOrganismo";

import VisorPdf from "../../components/Visorpdf";
import Modal from "../../components/Modal";

import Reporte from "./ReporteSeguimiento";
import { array } from "yup/lib/locale";
import Accion from "../../components/Accion";

import GeneradorExcelExpedientes from "./BotonExcel";
const TableCellHead = styled(TableCellMui)(({ theme }) => ({
  color: "#3c4b64",
  padding: theme.spacing(1, 1, 1, 1),
}));

const TableCell = styled(TableCellMui)(({ theme }) => ({
  padding: theme.spacing(1, 1, 1, 1),
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const EnhancedTableToolbar = (props) => {
  const [alignment, setAlignment] = React.useState("left");
  
  const [openDocumento, setOpenDocumento] = useState(false);
  const [documento, setDocumento] = useState("");
  

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const handleCloseDocument = () => {
    setOpenDocumento(false);
  };

  return (
    <>
      <Toolbar disableGutters>
        <Grid container spacing={1} align="left">
          <Grid item align="left">
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                flexWrap: "wrap",
              }}
            >
              <StyledToggleButtonGroup
                size="small"
                value={alignment}
                exclusive
                onChange={handleAlignment}
                aria-label="text accionGrupal"
              >
                <Reporte
                  tipo={props.tipo}
                  origen={props.origen}
                  destino={props.destino}
                  fecha_rango={props.fecha_rango}
                  datos={props.datos}
                  tipo_tramite={props.tipo_tramite}
                  destinoId={props.destinoId}
                  origenId={props.origenId}
                />
                <GeneradorExcelExpedientes
                  tipo={props.tipo}
                  origen={props.origen}
                  destino={props.destino}
                  rango={props.fecha_rango}
                  datos={props.datos}
                  tipo_tramite={props.tipo_tramite}
                  destinoId={props.destinoId}
                  origenId={props.origenId}
                />
              </StyledToggleButtonGroup>
            </Paper>
          </Grid>

          <Grid item sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
            {props.datos.length > 300 ? <Typography variant="aclaracion">La cantidad de registros para imprimir superan los 300. Por favor realizá una nueva búsqueda.</Typography> : null}
          </Grid>
        </Grid>

      </Toolbar>

      <Modal open={openDocumento} handleClose={handleCloseDocument} closeButton>
        <VisorPdf url={"data:application/octet-stream;base64," + documento} />
      </Modal>

    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,

};

const SeguirTramites = (props) => {

  const [fechaPdf, setFechaPdf] = useState('');
  const [origenPdf, setOrigenPdf] = useState('');
  const [destinoPdf, setDestinoPdf] = useState('');
  const [destinoIdPdf, setDestinoIdPdf] = useState('');
  const [origenIdPdf, setOrigenIdPdf] = useState('');
  const [organismoId, setOrganismoId] = useState('');
  const [tipoPdf, setTipoPdf] = useState('');
  const [tipoTramitePdf, setTipoTramitePdf] = useState('');
  const [actores, setActores] = useState([]);
  const [buscandoOrganismoDestino, setBuscandoOrganismoDestino] = useState(
    false
  );
  const [buscandoOrganismoOrigen, setBuscandoOrganismoOrigen] = useState(false);

  const dispatch = useDispatch();

  const leyendaOrganismo =
    "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Entradas-Salidas-Pendientes", ruta: "" },
  ];

  const [datos, setDatos] = useState([]);
  const [selected, setSelected] = useState([]);

  const [page, setPage] = React.useState(0);

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("Expediente");

  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [lblCriterios, setLblCriterios] = useState("Criterios de búsqueda");
  const [submitting, setSubmitting] = useState(false);
  const [expand, setExpand] = React.useState(true);

  const [tipoListado, setTipoListado] = useState("entradas");
  const [tipoTramite, setTipoTramite] = useState("E");

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - datos.length) : 0;


  const [usuario, setUsuario] = useState({
    organismoId: "",
    organismo: "",
  });

  useEffect(() => {
    api
      .datosUsuario()
      .then((res) =>
        setUsuario({
          organismoId: res.data.organismo,
          organismo: res.data.organismoDesc.slice(4), // Se eliminan los 4 primeros caracteres de la descripción del organismo por tratarse de guión con espacios ( -  )
        })
      )
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleOrganismoDestino = (organismoDestino = null) => {
    if (organismoDestino !== null) {
      formik.setFieldValue("orfIdDestino", organismoDestino.id);
      formik.setFieldValue(
        "organismoDestino",
        organismoDestino.descOrgCompleta
      );
    } else {
      formik.setFieldValue("orfIdDestino", "");
      formik.setFieldValue("organismoDestino", "");
    }
  };

  const handleOrganismoOrigen = (organismoOrigen = null) => {
    if (organismoOrigen !== null) {
      formik.setFieldValue("orfIdOrigen", organismoOrigen.id);
      formik.setFieldValue("organismoOrigen", organismoOrigen.descOrgCompleta);
    } else {
      formik.setFieldValue("orfIdOrigen", "");
      formik.setFieldValue("organismoOrigen", "");
    }
  };

  const handleOrganismoDestinoSelect = (organismoDestino = null) => {
    if (organismoDestino !== null) {
      formik.setFieldValue("orfIdDestino", organismoDestino.organismoId);
      formik.setFieldValue(
        "organismoDestino",
        organismoDestino.descripcion
      );
    } else {
      formik.setFieldValue("orfIdDestino", "");
      formik.setFieldValue("organismoDestino", "");
    }
  };

  const handleOrganismoOrigenSelect = (organismoOrigen = null) => {
    if (organismoOrigen !== null) {
      formik.setFieldValue("orfIdOrigen", organismoOrigen.organismoId);
      formik.setFieldValue("organismoOrigen", organismoOrigen.descripcion);
    } else {
      formik.setFieldValue("orfIdOrigen", "");
      formik.setFieldValue("organismoOrigen", "");
    }
  };

  const buscarOrganismoDestinoPorCodigo = (codigoOrganismo) => {
    setBuscandoOrganismoDestino(true);
    api
      .buscarOrganismo({
        id: codigoOrganismo,
        descripcion: "",
        alta: "N",
        accion: "consulta",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleOrganismoDestino(res.data[0]);
        } else {
          handleOrganismoDestino();
          dispatch(setError("No se encontró el organismo"));
        }
      })
      .catch((e) => {
        handleOrganismoDestino();
        dispatch(setError("Error al buscar el organismo"));
      })
      .finally(() => {
        setBuscandoOrganismoDestino(false);
      });
  };

  const buscarOrganismoOrigenPorCodigo = (codigoOrganismo) => {
    setBuscandoOrganismoOrigen(true);
    api
      .buscarOrganismo({
        id: codigoOrganismo,
        descripcion: "",
        alta: "N",
        accion: "consulta",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleOrganismoOrigen(res.data[0]);
        } else {
          handleOrganismoOrigen();
          dispatch(setError("No se encontró el organismo"));
        }
      })
      .catch((e) => {
        handleOrganismoOrigen();
        dispatch(setError("Error al buscar el organismo"));
      })
      .finally(() => {
        setBuscandoOrganismoOrigen(false);
      });
  };

  const handleorfIdDestino = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarOrganismoDestinoPorCodigo(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      formik.values.organismoDestino === "" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarOrganismoDestinoPorCodigo(event.target.value);
    }
    // }
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleorfIdOrigen = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarOrganismoOrigenPorCodigo(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      formik.values.organismoOrigen === "" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarOrganismoOrigenPorCodigo(event.target.value);
    }
    // }
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeorfIdDestino = (event) => {
    if (
      formik.values.organismoDestino !== "" &&
      formik.values.organismoDestino !== null
    )
      handleOrganismoDestino();
    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("orfIdDestino", event.target.value);
  };

  const handleChangeorfIdOrigen = (event) => {
    if (
      formik.values.organismoOrigen !== "" &&
      formik.values.organismoOrigen !== null
    )
      handleOrganismoOrigen();
    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("orfIdOrigen", event.target.value);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const headCells = [
    {
      id: "expediente",
      numeric: true,
      disablePadding: true,
      label: tipoTramite === "E" ? "Expediente" : "Trámite Interno",
      width: 150,
      align: "center",
    },
    {
      id: "descOrgGenCompleta",
      numeric: false,
      disablePadding: false,
      label: "Tramitado en",
      width: 400,
      align: "left",
    },
    {
      id: "asunto",
      numeric: false,
      disablePadding: false,
      label: "Asunto",
      width: 400,
      align: "left",
    },
    {
      id: "soporte",
      numeric: false,
      disablePadding: false,
      label: "Soporte",
      width: 50,
      align: "center",
    },
  ];

  function EnhancedTableHead(props) {
    const {
      order,
      orderBy,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCellHead
              key={headCell.id}
              align={headCell.align}
              padding="normal"
              sortDirection={orderBy === headCell.id ? order : false}
              width={headCell.width}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                <b>{headCell.label}</b>
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "ordenado descendente"
                      : "ordenado ascendente"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCellHead>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
              <KeyboardArrowLeft />
            )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
              <KeyboardArrowRight />
            )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };


  const validationSchema = Yup.object().shape({
    tipoTramite: Yup.string(),
    tipoListado: Yup.string(),
    orfIdDestino: Yup.number(),
    organismoDestino: Yup.string(),
    orfIdOrigen: Yup.number(),
    organismoOrigen: Yup.string(),
    fechaDesde: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .min("01/01/1992", "Fecha no válida")
      .max(new Date(), "Fecha no válida"),
    fechaHasta: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .max(new Date(), "Fecha no válida")
      .min(Yup.ref("fechaDesde"), "Rango fecha no válido"),
      digital: Yup.string()
  });


  const formik = useFormik({
    initialValues: {
      tipoTramite: "E",
      tipoListado: "entradas",
      orfIdDestino: usuario.organismoId,
      organismoDestino: usuario.organismo,
      orfIdOrigen: "",
      organismoOrigen: "",
      fechaDesde: "",
      fechaHasta: "",
      digital: "T",
      actor:0
    },
    lblCriterios: "Criterios de búsqueda",
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setDatos([]);
      setLblCriterios("Criterios de búsqueda");
      setPage(0);
      formik.values.fechaDesde !== "" ||
        formik.values.fechaHasta !== "" ||
        formik.values.orfIdDestino !== "" ||
        formik.values.orfIdOrigen !== ""
        ? setLblCriterios("Criterios aplicados")
        : setLblCriterios("Criterios de búsqueda");
      buscarTramites(values);
    },
    onReset: () => {
      setDatos([]);
      formik.values.fechaDesde = "";
      formik.values.fechaHasta = "";
      setLblCriterios("Criterios de búsqueda");
    },
  });
  const buscarActoresOrganismo = () => {
  /*  let usuarios= [{
      actor_id:18203,
      descripcion:"Mauro Iván Joannas"
    },];
    setActores([...usuarios]); */
     api.buscarActoresOrganismo({organismoId:organismoId})
        .then((res) => {
          setActores(res.data);
        })
        .catch((e) => {
          dispatch(setError(e.response.data.error));
          console.log("Error al buscar usuarios");
        });
  };
  console.log(actores);
  const buscarTramites = (filtros) => {
    setSubmitting(true);
    setDatos([]);
    api
      .seguimientoTramites({
        fechaDesde: formik.values.fechaDesde,
        fechaHasta: formik.values.fechaHasta,
        orfIdOrigen: formik.values.orfIdOrigen,
        orfIdDestino: formik.values.orfIdDestino,
        tipoTramite: formik.values.tipoTramite,
        tipoListado: formik.values.tipoListado,
        soporte: formik.values.digital,
        actor_id_recibio: formik.values.actor===0 ? "" :formik.values.actor
      })
      .then((res) => {

        let data = [];

        if (formik.values.digital === 'S'){
           data = res.data.filter(element => element.soporte === 'DIGITAL');
        }
        if (formik.values.digital === 'N'){
           data = res.data.filter(element => element.soporte === 'EN PAPEL');
        }
        if (formik.values.digital === 'T'){
          data = res.data;
       }
    
        setDatos(data);
        setSelected([]);
        let fechaDesde = formik.values.fechaDesde.split("-");
        let fechaHasta = formik.values.fechaHasta.split("-");
        setFechaPdf("desde el " + fechaDesde[2] + "/" + fechaDesde[1] + "/" + fechaDesde[0] + " al " + fechaHasta[2] + "/" + fechaHasta[1] + "/" + fechaHasta[0]);
        setTipoPdf(formik.values.tipoListado);
        setOrigenPdf(formik.values.organismoOrigen);
        setDestinoPdf(formik.values.organismoDestino);
        setTipoTramitePdf(formik.values.tipoTramite);
        setDestinoIdPdf(formik.values.orfIdDestino);
        setOrigenIdPdf(formik.values.orfIdOrigen);
    
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
        console.log("Error al cargar los datos");
      })
      .finally(() => setSubmitting(false));
  };

  const handleChangeTipoListado = (event) => {
    if (event.target.value === "salidas") {
      setTipoListado("salidas");
      formik.setFieldValue("orfIdOrigen", usuario.organismoId);
      formik.setFieldValue("organismoOrigen", usuario.organismo);
      formik.setFieldValue("orfIdDestino", "");
      formik.setFieldValue("organismoDestino", "");
    } else {
      setTipoListado("entradas");
      formik.setFieldValue("orfIdDestino", usuario.organismoId);
      formik.setFieldValue("organismoDestino", usuario.organismo);
      formik.setFieldValue("orfIdOrigen", "");
      formik.setFieldValue("organismoOrigen", "");
    }
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeTipoTramite = (event) => {
    if (event.target.value === "E") {
      setTipoTramite("E");
    } else {
      setTipoTramite("T");
    }
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaDesde = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaHasta = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };
  useEffect(() => {
    if (formik.values.tipoListado === "entradas") {
      setOrganismoId(formik.values.orfIdDestino);
    }else {
      setOrganismoId(formik.values.orfIdOrigen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.tipoListado,formik.values.orfIdDestino,formik.values.orfIdOrigen]);
  useEffect(() => {
    if(organismoId !== ''){
      buscarActoresOrganismo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organismoId]);
  return (
    <MinimalPage breadcrumbs={breadcrumbs} disableCheckAuth>
      <Accordion
        sx={{ pl: 1, pr: 1 }}
        disableGutters
        expanded={expand}
        onChange={toggleAcordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-filtros"
          id="panel-filtros"
          sx={{ height: "50px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <FilterAltOutlinedIcon
              color={submitting ? "secondary" : "primary"}
              sx={{ mr: 1, display: { xs: "none", md: "inline" } }}
            />
            <Typography variant="cuerpo">{lblCriterios}</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 1 }}>
          <form
            id="buscador"
            name="buscador"
            onSubmit={formik.handleSubmit}
            onReset={formik.handleReset}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={12} sx={{ mb: 0 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={8}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} lg={4}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            formik.touched.tipoListado &&
                            Boolean(formik.errors.tipoListado)
                          }
                          fullWidth
                        >
                          <InputLabel id="tipoListadoLabel">
                            Tipo de listado
                          </InputLabel>
                          <Select
                            labelId="tipoListadoLabel"
                            id="tipoListado"
                            name="tipoListado"
                            variant="outlined"
                            label="Tipo de Listado"
                            value={formik.values.tipoListado}
                            onChange={handleChangeTipoListado}
                          >
                            <MenuItem value="entradas" selected>ENTRADAS</MenuItem>
                            <MenuItem value="salidas">SALIDAS</MenuItem>
                            <MenuItem value="pendientes">PENDIENTES</MenuItem>
                          </Select>
                          <FormHelperText>
                            {formik.touched.tipoListado &&
                              formik.errors.tipoListado}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            formik.touched.tipoTramite &&
                            Boolean(formik.errors.tipoTramite)
                          }
                          fullWidth
                        >
                          <InputLabel id="tipoTramiteLabel">
                            Tipo de trámite
                          </InputLabel>
                          <Select
                            labelId="tipoTramiteLabel"
                            id="tipoTramite"
                            name="tipoTramite"
                            variant="outlined"
                            label="Tipo de trámite"
                            value={formik.values.tipoTramite}
                            onChange={handleChangeTipoTramite}
                          >
                            <MenuItem value="E" selected>EXPEDIENTE</MenuItem>
                            <MenuItem value="T">TRÁMITE INTERNO</MenuItem>
                          </Select>
                          <FormHelperText>
                            {formik.touched.tipoTramite &&
                              formik.errors.tipoTramite}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={4} sx={{ mb: 1 }}>
                          <FormControl
                            variant="outlined"
                            size="small"
                            error={
                              formik.touched.digital && Boolean(formik.errors.digital)
                            }
                            fullWidth
                          >
                            <InputLabel id="digitalLabel">Soporte</InputLabel>
                            <Select
                              labelId="digitalLabel"
                              id="digital"
                              name="digital"
                              variant="outlined"
                              label="Soporte"
                              value={formik.values.digital}
                              onChange={formik.handleChange}
                            >
                              <MenuItem value="T">TODOS</MenuItem>
                              <MenuItem value="S">DIGITAL</MenuItem>
                              <MenuItem value="N">PAPEL</MenuItem>
                            </Select>
                            <FormHelperText>
                              {formik.touched.digital && formik.errors.digital}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      <Grid item xs={12} lg={12} sx={{ mb: 0 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} lg={2}>
                            <TextField
                              id="orfIdOrigen"
                              name="orfIdOrigen"
                              label="Código de organismo"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={formik.values.orfIdOrigen}
                              disabled={tipoListado === "salidas"}
                              onChange={handleChangeorfIdOrigen}
                              onKeyDown={handleorfIdOrigen}
                              onBlur={handleorfIdOrigen}
                              error={
                                formik.touched.orfIdOrigen &&
                                Boolean(formik.errors.orfIdOrigen)
                              }
                              helperText={
                                formik.touched.orfIdOrigen &&
                                formik.errors.orfIdOrigen
                              }
                            />
                            <Typography
                              variant="aclaracion"
                              sx={{
                                display: {
                                  xs: "inline",
                                  sm: "inline",
                                  md: "inline",
                                  lg: "none",
                                },
                              }}
                            >
                              {tipoListado !== "salidas" ? leyendaOrganismo : null}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} lg={10}>
                            <Box display="flex" flexDirection="row">
                              <TextField
                                id="organismoOrigen"
                                name="organismoOrigen"
                                label="Organismo de origen"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={formik.values.organismoOrigen}
                                onChange={formik.handleChangeOrganismoOrigen}
                                error={
                                  formik.touched.organismoOrigen &&
                                  Boolean(formik.errors.organismoOrigen)
                                }
                                helperText={
                                  formik.touched.organismoOrigen &&
                                  formik.errors.organismoOrigen
                                }
                                disabled
                              />
                              {tipoListado !== "salidas" ? (
                                buscandoOrganismoOrigen ? (
                                  <CircularProgress
                                    color="primary"
                                    size={20}
                                    sx={{ margin: 1 }}
                                  />
                                ) : (
                                    <BuscadorOrganismo
                                      resultado={handleOrganismoOrigen}
                                      activo={"T"}
                                      alta={"N"}
                                      accion="consulta"
                                    />
                                  )
                              ) : (
                                <Accion funcion={props.funcion} accion="ocultarLupa">
                                 <SeleccionarOrganismo
                                      resultado={handleOrganismoOrigenSelect}
                                      activo={"T"}
                                      alta={"N"}
                                      accion="consulta"
                                    /> 
                                  
                                </Accion>
                                )}
                            </Box>
                          </Grid>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              lg={12}
                              sx={{ ml: 1, mt: 0, mb: 1, pt: 0 }}
                            >
                              <Typography
                                variant="aclaracion"
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "none",
                                    lg: "inline",
                                  },
                                }}
                              >
                                {tipoListado !== "salidas" ? leyendaOrganismo : null}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} lg={12} sx={{ mb: 0 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} lg={2}>
                            <TextField
                              id="orfIdDestino"
                              name="orfIdDestino"
                              label="Código de organismo"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={formik.values.orfIdDestino}
                              disabled={tipoListado === "entradas"}
                              onChange={handleChangeorfIdDestino}
                              onKeyDown={handleorfIdDestino}
                              onBlur={handleorfIdDestino}
                              error={
                                formik.touched.orfIdDestino &&
                                Boolean(formik.errors.orfIdDestino)
                              }
                              helperText={
                                formik.touched.orfIdDestino &&
                                formik.errors.orfIdDestino
                              }
                            />
                            <Typography
                              variant="aclaracion"
                              sx={{
                                display: {
                                  xs: "inline",
                                  sm: "inline",
                                  md: "inline",
                                  lg: "none",
                                },
                              }}
                            >
                              {tipoListado !== "entradas" ? leyendaOrganismo : null}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} lg={10}>
                            <Box display="flex" flexDirection="row">
                              <TextField
                                id="organismoDestino"
                                name="organismoDestino"
                                label="Organismo de destino"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={formik.values.organismoDestino}
                                onChange={formik.handleChangeOrganismoDestino}
                                error={
                                  formik.touched.organismoDestino &&
                                  Boolean(formik.errors.organismoDestino)
                                }
                                helperText={
                                  formik.touched.organismoDestino &&
                                  formik.errors.organismoDestino
                                }
                                disabled
                              />
                              {tipoListado !== "entradas" ? (
                                buscandoOrganismoDestino ? (
                                  <CircularProgress
                                    color="primary"
                                    size={20}
                                    sx={{ margin: 1 }}
                                  />
                                ) : (
                                    <BuscadorOrganismo
                                      resultado={handleOrganismoDestino}
                                      activo={"T"}
                                      alta={"N"}
                                      accion="consulta"
                                    />
                                  )
                              ) : (
                                <Accion funcion={props.funcion} accion="ocultarLupa">
                                  <SeleccionarOrganismo
                                    resultado={handleOrganismoDestinoSelect}
                                    activo={"T"}
                                    alta={"N"}
                                    accion="consulta"
                                  /> 
                                </Accion>
                               
                            
                                )}
                            </Box>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            lg={12}
                            sx={{ mt: 0, mb: 1, pt: 0 }}
                          >
                            <Typography
                              variant="aclaracion"
                              sx={{
                                display: {
                                  xs: "none",
                                  sm: "none",
                                  md: "none",
                                  lg: "inline",
                                },
                              }}
                            >
                              {tipoListado !== "entradas" ? leyendaOrganismo : null}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={4} sx={{ mb: 1 }}>
                    <Card>
                      <CardContent sx={{ padding: 1, height: "auto" }}>
                        <Typography variant="cuerpo">
                          Fecha de movimiento
                        </Typography>
                        <Divider />
                        {/* aquí divido en 2 celdas */}
                        <Grid container spacing={1}>
                          <Grid item xs={6} lg={6} sx={{ mb: 1 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              sx={{ marginTop: 2 }}
                              error={
                                formik.touched.fechaDesde &&
                                Boolean(formik.errors.fechaDesde)
                              }
                              fullWidth
                            >
                              <TextField
                                id="fechaDesde"
                                type="date"
                                value={formik.values.fechaDesde}
                                label="Fecha desde"
                                variant="outlined"
                                size="small"
                                onChange={handleChangeFechaDesde}
                                InputLabelProps={{ shrink: true }}
                              />
                              <FormHelperText>
                                {formik.touched.fechaDesde &&
                                  formik.errors.fechaDesde}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6} lg={6} sx={{ mb: 1 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              sx={{ marginTop: 2 }}
                              error={
                                formik.touched.fechaHasta &&
                                Boolean(formik.errors.fechaHasta)
                              }
                              fullWidth
                            >
                              <TextField
                                id="fechaHasta"
                                type="date"
                                value={formik.values.fechaHasta}
                                label="Fecha hasta"
                                variant="outlined"
                                size="small"
                                onChange={handleChangeFechaHasta}
                                InputLabelProps={{ shrink: true }}
                              />
                              <FormHelperText>
                                {formik.touched.fechaHasta &&
                                  formik.errors.fechaHasta}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        </Grid>
                       
                        {/* Fin de 2 celdas */}
                      </CardContent>
                    </Card>
                       <Accion funcion={props.funcion} accion="ocultarActor"> 
                        
                      
                     <Grid container spacing={1}>
                        <Grid item xs={12} lg={12} sx={{ mt:2,mb: 1 }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          fullWidth
                          error={formik.touched.actor && Boolean(formik.errors.actor)}
                        >
                          <InputLabel id="actorLabel">{formik.values.tipoListado === "salidas" ? "Enviado por" : "Recibido por" }</InputLabel>
                          <Select
                            labelId="actorLabel"
                            id="actor"
                            name="actor"
                            variant="outlined"
                            label="Recibido por"
                            value={formik.values.actor}
                            onChange={formik.handleChange}
                          >
                             <MenuItem value={0}>Seleccione</MenuItem>
                                {actores.map((item) => (
                                  <MenuItem key={item.act_id} value={item.act_id}>
                                    {item.documento+' - '+item.apelido+" "+item.nombre}
                                  </MenuItem>
                              ))}
                          </Select>
                          <FormHelperText>
                            {formik.touched.actor && formik.errors.actor}
                          </FormHelperText>
                        </FormControl>
                        </Grid>
                        </Grid>
                         </Accion> 
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}></Grid>
            <Grid container spacing={1} sx={{ pl: 2, pr: 1, paddingLeft: 1 }}>
              <Grid item lg={12} xs={12} align="right">
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Button
                    variant="plata"
                    type="reset"
                    sx={{ m: 1 }}
                    endIcon={<CachedIcon />}
                  >
                    Limpiar
                  </Button>{" "}
                  <Button
                    variant="gris"
                    type="submit"
                    disabled={submitting}
                    sx={{ m: 1 }}
                    endIcon={<SearchIcon />}
                  >
                    {submitting ? "Buscando..." : "Buscar"}
                  </Button>
                </Box>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <IconButton color="primary" type="reset" title="Limpiar">
                    <CachedIcon />
                  </IconButton>{" "}
                  <IconButton
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    title="Buscar"
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
      <br></br>
      <Card>
        <CardContent>

          <EnhancedTableToolbar
            numSelected={selected.length}
            selected={selected}
            datos={datos}
            fechaDesde={formik.values.fechaDesde}
            fechaHasta={formik.values.fechaHasta}
            orfIdOrigen={formik.values.orfIdOrigen}
            orfIdDestino={formik.values.orfIdDestino}
            origenDesc={formik.values.origenDesc}
            destinoDesc={formik.values.destinoDesc}
            tipoTramite={formik.values.tipoTramite}
            tipoListado={formik.values.tipoListado}
            resetearTabla={() => buscarTramites(formik.values)}
            tipo={tipoPdf}
            origen={origenPdf}
            destino={destinoPdf}
            fecha_rango={fechaPdf}
            tipo_tramite={tipoTramitePdf}
            destinoId={destinoIdPdf}
            origenId={origenIdPdf}
          />
          <TableContainer>
            <Table
              sx={{ minWidth: 750, border: "1px solid #dee2e6" }}
              aria-labelledby="tableTitle"
              size="small"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={datos.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                {stableSort(datos, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((dato, index) => {
                    const isItemSelected = isSelected(dato);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={dato.id}
                        selected={isItemSelected}
                        sx={
                          index % 2 === 0
                            ? { backgroundColor: "#f2f2f2" }
                            : { backgroundColor: "#fff" }
                        }
                      >
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          sx={{ pl: 2 }}
                        >
                          {
                            tipoTramite === "E"
                              ? dato.expedienteConFecha
                              : dato.fechaTramiteInterno !== "" && dato.fechaExpediente !== "" && dato.fechaTramiteInterno !== dato.fechaExpediente ? dato.tramiteInternoConFecha : null
                          }
                        </TableCell>
                        <TableCell align="left">
                          {dato.descOrgGenCompleta}
                        </TableCell>
                        <TableCell align="left">{dato.asunto}</TableCell>
                        <TableCell align="left">{dato.soporte}</TableCell>
                      </TableRow>
                    );
                  })}
                {submitting ? (
                  <TableRow>
                    <TableCell colSpan="7" align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                    null
                  )}
                {datos.length === 0 && !submitting ? (
                  <TableRow>
                    <TableCell colSpan="7" align="center">
                      <Typography variant="aclaracion">No hay datos para mostrar</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                    null
                  )}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "Todos", value: datos.length },
                    ]}
                    count={datos.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    selected={selected}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

    </MinimalPage>
  );
};

export default SeguirTramites;